(function() {
  "use strict";
  angular.module("marketPlace.cms", []);
})();
